/* eslint-disable */

/** Nearby (or BLE) is the feature that enables seeing Cash customers in the vicinity. */
export enum NearbyVisibility {
  /** EVERYONE - Everyone can see full name and profile photo */
  EVERYONE = "EVERYONE",
  /** CONTACTS_ONLY - If customer A has customer B in her contacts, customer B can see customer A via BLE */
  CONTACTS_ONLY = "CONTACTS_ONLY",
}
